














import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import firebase from "firebase/app";
import { LoginState } from "@/store/modules/user";

// import MetaSetting from "src/scripts/metaSetting";
@Component({
    components: {},
})
export default class Play extends Vue {
    @Prop() private pathname!: string;

    private gameData: any;
    private url: string = "";
    private initLauncher: boolean = false;
    private iframeHeight: string = "";

    async mounted() {
        this.gameData = this.$store.getters.gameByPathname(this.pathname);

        if (!this.gameData) {

            //todo 게임 요청
            const result = await this.$api.game(this.pathname);
            console.log(result)
            if (!result && result.error) {
                console.error((result && result.error) || "error");
            } else {
                this.gameData = result.game;
                // const title = this.gameData?.title;
                // const description = this.gameData?.description;
                // const thumb = this.gameData?.url_thumb;
                // const author = this.gameData?.user.name;

            }
        }

        this.url = `${process.env.VUE_APP_LAUNCHER_URL}game/${this.gameData.pathname}`;
        // document.title = this.gameData.title;

        // this.url = `game/${this.gameData.pathname}`;

        window.addEventListener("message", this.onMessage);
        window.addEventListener("resize", this.onResize);
        this.onResize();

        // this.tagEvent();
    }

    beforeDestroy() {
        window.removeEventListener("message", this.onMessage);
        window.removeEventListener("resize", this.onResize);

        // if (this.metaSetting) {
        //     this.metaSetting.reset();
        //     this.metaSetting = null;
        // }
    }

    onResize() {
        // this.iframeWidth = `${window.innerWidth}px`;
        this.iframeHeight = `${window.innerHeight}px`;
    }

    @Watch("$store.getters.idToken")
    onChangedToken() {
        this.toMessage({
            type: "@updateToken",
            token: this.$store.getters.idToken,
        });
    }

    async onMessage(msg: MessageEvent) {
        const { type, channel_id } = msg.data;

        switch (type) {
            case "@initLauncher": {
                this.initLauncher = true;
                this.toMessage({ type: "@initParent" });
                const loginState = await this.$store.dispatch("loginState");
                this.onChangedToken();
                break;
            }
            case "@refreshToken": {
                const currentUser = firebase.auth().currentUser;
                if (currentUser) {
                    const idToken = await currentUser.getIdToken(true);
                    this.$store.commit("idToken", idToken);
                }
                break;
            }
            case "@requestLogin": {
                this.$store.commit("redirectRouter", this.$route.fullPath);
                await this.$router.replace("/login");
                break;
            }
            case "@exit": {
                this.exit();
                break;
            }
            case "@moveChannel": {
                await this.$router.push(`/${this.$i18n.locale}/channel/${channel_id}`);
                break;
            }
        }
    }

    toMessage(message: any) {
        const iframe = this.$refs.game as HTMLIFrameElement;
        if (iframe.contentWindow) {
            iframe.contentWindow.postMessage(message, "*");
        }
    }

    exit() {
        if (this.$store.getters.fromRouterName) {
            this.$router.back();
        } else {
            this.$router.push(`/${this.$i18n.locale}`);
        }
    }

    // tagEvent() {
    //     this.$gtag &&
    //         this.$gtag.event("play", {
    //             event_category: "game",
    //             event_label: "title",
    //             value: this.gameData.title,
    //         });
    // }
}
